/* Falconclaw PTT — Cable finder (native rows + per-row model browsing + alias search)
   + Wing add-to-cart + live prices. Rewritten 2026-06-25 (session 3k); APX row = full
   12-pin GCAI set + space-insensitive search 2026-09-21. The radio
   model lists are now SHOWN natively (collapsed per cable row, expand on click),
   and search auto-expands + highlights the matching radio, mirroring the Woo
   "Find Your Downlead" capability in the Shopify/Impact card style.
   The cable rows themselves live in fc2.showcase_html; this script fills each
   row's hidden model panel ([data-fc-models-for="<group>"]) and drives search. */
(function () {
  'use strict';

  function variantIdFromUrl(url) {
    var m = url.match(/[?&]id=(\d+)/);
    return m ? m[1] : '';
  }

  /* group key = the data-fc-cab-group on each .fc-cab-row. Models + aliases
     are the Falconclaw compatibility set (most-common models per connector;
     full coverage is 1200+, handled by Request a cable). */
  var data = {
    'kenwood':   { brands: 'Baofeng, Retevis, TYT, Wouxun, Kenwood', models: ['Baofeng UV-5R','Baofeng UV-82','Baofeng BF-F8HP', { name: 'Baofeng BF-888S', aka: ['Pofung 888S'] }, 'Retevis RT21','Baofeng UV-5RA','Baofeng GT-3','Baofeng UV-17','Retevis RT22','Retevis RT5R','TYT TH-UV88','Wouxun KG-UV8H','Wouxun KG-935G','Kenwood TK-3400','Kenwood TK-2400','Kenwood TK-3300'] },
    '6pin-nato': { brands: 'Harris, TRI, TCA, FCS, Thales', models: [{ name: 'AN/PRC-152 (Harris Falcon III)', aka: ['Falcon III','Falcon 3','Harris 152','L3Harris 152','PRC-152'] },{ name: 'AN/PRC-152A', aka: ['PRC-152A'] },{ name: 'AN/PRC-148 MBITR', aka: ['MBITR','PRC-148','Thales 148'] },{ name: 'Harris RF-310 (export PRC-152 variant)', aka: ['RF-310','Harris 310'] },{ name: 'TRI PRC-152', aka: ['TRI 152'] },'TCA PRC-152A','FCS PRC-152A','TCA PRC-148','TRI PRC-148',{ name: 'Thales MBITR Enhanced', aka: ['MBITR Enhanced','Thales MBITR'] }] },
    '9pin-fischer': { brands: 'Harris', models: [{ name: 'RF-7800S', aka: ['SPR','Soldier Personal Radio','Harris SPR','Harris 7800'] },{ name: 'RF-7850S', aka: ['Harris 7850'] }] },
    'icom':      { brands: 'ICOM, Cobra, Ritron', models: ['IC-F3 (and variants)','IC-F4 (and variants)','IC-F10','IC-F20','IC-H2','IC-H6','IC-J12','IC-M5','IC-U12','IC-U16','Cobra and Ritron series'] },
    'icom-14pin': { brands: 'ICOM (IDAS digital)', models: [{ name: 'IC-F3400D', aka: ['F3400D','IDAS'] },{ name: 'IC-F4400D', aka: ['F4400D','IDAS'] },{ name: 'IC-F52D', aka: ['F52D','IDAS'] },{ name: 'IC-F62D', aka: ['F62D','IDAS'] },{ name: 'IC-F3360D', aka: ['F3360D','IDAS'] },{ name: 'IC-F4360D', aka: ['F4360D','IDAS'] },{ name: 'IC-F3261D', aka: ['F3261D','IDAS'] },{ name: 'IC-F3263D', aka: ['F3263D','IDAS'] },{ name: 'IC-F4261D', aka: ['F4261D','IDAS'] },{ name: 'IC-F4263D', aka: ['F4263D','IDAS'] }] },
    '2pin-moto': { brands: 'Motorola', models: ['CP040','GP300','CP080','CP88','CP100','CP125','CP145','CP150','XNT446','XTN500','XTN600','XTNI','XTNID','XT400','XT420','XT460','HANDIEPRO','HANDIECOM','GP280','P110','SP50'] },
    'gp340':     { brands: 'Motorola GP, HT, MTX, PRO', models: ['Motorola GP340','Motorola GP320','Motorola GP360','Motorola GP380','Motorola GP328','Motorola GP338','Motorola GP640','Motorola GP680','Motorola HT750','Motorola HT1250','Motorola HT1550','Motorola MTX850','Motorola MTX950','Motorola PRO5150'] },
    'apx':       { brands: 'Motorola APX, MOTOTRBO, TETRA (12-pin GCAI)', models: ['APX 900',{ name: 'APX 1000', aka: ['APX 1000i'] },'APX 2000','APX 3000',{ name: 'APX 4000', aka: ['APX 4000XH','APX 4000Li'] },'APX 5000',{ name: 'APX 6000', aka: ['APX 6000XE','APX 6000Li'] },{ name: 'APX 7000', aka: ['APX 7000XE'] },{ name: 'APX 8000', aka: ['APX 8000XE','APX 8000H','APX 8000HXE'] },{ name: 'APX NEXT', aka: ['APX NEXT XE','APX NEXT XN'] },'SRX 2200','XPR 6100','XPR 6350','XPR 6380','XPR 6550','XPR 6580',{ name: 'XPR 7350', aka: ['XPR 7350e'] },{ name: 'XPR 7380', aka: ['XPR 7380e'] },{ name: 'XPR 7550', aka: ['XPR 7550e','XPR 7550 IS'] },{ name: 'XPR 7580', aka: ['XPR 7580e','XPR 7580e IS'] },{ name: 'DP 3400', aka: ['DP3401'] },{ name: 'DP 3600', aka: ['DP3601'] },{ name: 'DP 4400', aka: ['DP4401','DP4400e','DP4401e'] },{ name: 'DP 4600', aka: ['DP4601','DP4600e','DP4601e'] },{ name: 'DP 4800', aka: ['DP4801','DP4800e','DP4801e'] },'DGP 5050e','DGP 5550e','DGP 8050e','DGP 8550e',{ name: 'DGP 4150', aka: ['DGP 4100 series'] },{ name: 'DGP 6150', aka: ['DGP 6100 series'] },'XiR P8200','XiR P8268',{ name: 'XiR P8600', aka: ['P8600i'] },{ name: 'XiR P8608', aka: ['P8608i'] },'XiR P8620',{ name: 'XiR P8628', aka: ['P8628i'] },{ name: 'XiR P8660', aka: ['P8660i'] },{ name: 'XiR P8668', aka: ['P8668i'] },'XiR P8808R',{ name: 'GP328D', aka: ['GP328D Plus','GP328D+'] },{ name: 'GP338D', aka: ['GP338D Plus','GP338D+'] },'MTP6650','MTP6550','MTP6750','MTP850S','MTP850 FuG','MTP830S'] },
    'sepura':    { brands: 'Sepura', models: [{ name: 'Sepura STP8000', aka: ['STP8000'] },{ name: 'Sepura STP9000', aka: ['STP9000'] },{ name: 'Sepura STP series', aka: ['STP'] }] }
  };

  function getName(m) { return typeof m === 'string' ? m : m.name; }
  /* norm(): lower-case and drop spaces/hyphens/slashes/dots/underscores on BOTH sides, so
     "APX1000", "apx-1000" and "APX 1000" are the same query (21.09.2026: "APX1000" returned
     "No match" because the list only carried spaced names + a few unspaced aliases). */
  function norm(s) { return String(s || '').toLowerCase().replace(/[\s\-_\/.]+/g, ''); }
  /* hit(): a query of 4+ chars may sit anywhere in the squashed name ("apx1000" in "apx1000");
     a shorter one must START a word of the name, so "r7" (MOTOTRBO R7 = NOT compatible) does
     not light up "XPR 7350" through the squashed "xpr7350". */
  function hit(text, q) {
    if (norm(text).indexOf(q) === -1) return false;
    if (q.length >= 4) return true;
    var toks = String(text).toLowerCase().split(/[\s\-_\/.]+/);
    for (var i = 0; i < toks.length; i++) if (toks[i].indexOf(q) === 0) return true;
    return false;
  }
  function modelMatches(m, t) {
    var q = norm(t);
    if (!q) return false;
    if (hit(getName(m), q)) return true;
    if (typeof m === 'object' && m.aka) for (var i = 0; i < m.aka.length; i++) if (hit(m.aka[i], q)) return true;
    return false;
  }
  function getMatchedAlias(m, t) {
    var q = norm(t);
    if (!q || typeof m === 'string') return null;
    if (hit(m.name, q)) return null;
    if (m.aka) for (var i = 0; i < m.aka.length; i++) if (hit(m.aka[i], q)) return m.aka[i];
    return null;
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }

  /* Fill each row's model panel once. Chips use the native .fc-cab-chip class
     (styled in the showcase <style>); highlight + alias are toggled by search. */
  function buildModelPanels() {
    var panels = document.querySelectorAll('[data-fc-models-for]');
    panels.forEach(function (panel) {
      if (panel.dataset.fcBuilt === '1') return;
      var key = panel.dataset.fcModelsFor;
      var d = data[key];
      if (!d) return;
      var html = '';
      d.models.forEach(function (m, i) {
        html += '<span class="fc-cab-chip" data-fc-chip-idx="' + i + '">' + escapeHtml(getName(m)) +
                '<span class="fc-cab-chip__alias" hidden></span></span>';
      });
      panel.innerHTML = html;
      panel.dataset.fcBuilt = '1';
      // set the toggle count label
      var row = panel.closest('.fc-cab-row');
      if (row) {
        var cnt = row.querySelector('[data-fc-models-count]');
        if (cnt) cnt.textContent = d.models.length;
      }
    });
  }

  function setRowExpanded(row, expanded) {
    var panel = row.querySelector('[data-fc-models-for]');
    var toggle = row.querySelector('.fc-cab-row__toggle');
    if (!panel) return;
    if (expanded) { row.classList.add('is-open'); panel.hidden = false; }
    else { row.classList.remove('is-open'); panel.hidden = true; }
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  /* Apply a search term: filter rows, highlight matched chips, auto-expand matches. */
  function applySearch(term) {
    var t = (term || '').trim().toLowerCase();
    var rows = document.querySelectorAll('.fc-cab-row');
    rows.forEach(function (row) {
      var key = row.dataset.fcCabGroup;
      var d = data[key];
      var panel = row.querySelector('[data-fc-models-for]');
      var chips = panel ? panel.querySelectorAll('.fc-cab-chip') : [];
      var matchCount = 0;
      if (d) {
        d.models.forEach(function (m, i) {
          var chip = chips[i];
          if (!chip) return;
          var isHl = t && modelMatches(m, t);
          var aliasEl = chip.querySelector('.fc-cab-chip__alias');
          if (isHl) {
            matchCount++;
            chip.classList.add('is-hl');
            var alias = getMatchedAlias(m, t);
            if (alias && aliasEl) { aliasEl.textContent = '← “' + alias + '”'; aliasEl.hidden = false; }
            else if (aliasEl) { aliasEl.hidden = true; aliasEl.textContent = ''; }
          } else {
            chip.classList.remove('is-hl');
            if (aliasEl) { aliasEl.hidden = true; aliasEl.textContent = ''; }
          }
        });
      }
      if (!t) {
        // reset: no dim, collapse, clear highlight
        row.classList.remove('is-dim');
        setRowExpanded(row, false);
      } else if (matchCount > 0) {
        row.classList.remove('is-dim');
        setRowExpanded(row, true);
      } else {
        row.classList.add('is-dim');
        setRowExpanded(row, false);
      }
    });
    reorderRows(!!t);
  }
  /* Matched rows (not .is-dim) move above the dimmed ones, keeping their relative order; with
     no search term the rows go back to the order the showcase HTML gave them. Each parent that
     holds rows is handled on its own (mobile + desktop copies). */
  function reorderRows(searching) {
    var parents = [];
    document.querySelectorAll('.fc-cab-row').forEach(function (row) {
      if (row.dataset.fcOrigIdx === undefined) {
        row.dataset.fcOrigIdx = String(Array.prototype.indexOf.call(row.parentNode.children, row));
      }
      if (parents.indexOf(row.parentNode) === -1) parents.push(row.parentNode);
    });
    parents.forEach(function (parent) {
      var rows = Array.prototype.filter.call(parent.children, function (el) { return el.classList.contains('fc-cab-row'); });
      var sorted = rows.slice().sort(function (a, b) {
        var da = searching && a.classList.contains('is-dim') ? 1 : 0;
        var db = searching && b.classList.contains('is-dim') ? 1 : 0;
        if (da !== db) return da - db;
        return Number(a.dataset.fcOrigIdx) - Number(b.dataset.fcOrigIdx);
      });
      var changed = sorted.some(function (r, i) { return r !== rows[i]; });
      if (!changed) return;
      var end = rows[rows.length - 1].nextSibling;   // captured BEFORE any move; null = append
      sorted.forEach(function (r) { parent.insertBefore(r, end); });
    });
  }

  /* The "found N models" message + the matched cable(s) with inline Add. */
  function searchFromInput(value) {
    var msgs = document.querySelectorAll('#fcSearchMsg');
    var t = (value || '').trim().toLowerCase();
    if (!t || t.length < 2) {
      msgs.forEach(function (m) { m.innerHTML = ''; m.hidden = true; });
      applySearch('');
      return;
    }
    var total = 0, matchedKeys = [];
    Object.keys(data).forEach(function (group) {
      var c = data[group].models.filter(function (m) { return modelMatches(m, t); }).length;
      if (c > 0) { total += c; matchedKeys.push(group); }
    });
    var html;
    if (total > 0) {
      var singleVid = '', singleSoldout = false;
      var labels = matchedKeys.map(function (k) {
        var row = document.querySelector('.fc-cab-row[data-fc-cab-group="' + k + '"]');
        var nm = row ? (row.querySelector('.fc-cab-row__name') || {}).textContent : k;
        var vid = row ? row.dataset.fcVariantId : '';
        var soldout = row && row.dataset.fcSoldout === '1';
        // live price of the row, once the price loader has filled it ("from €68.20")
        var priceEl = row ? row.querySelector('[data-fc-price-for]') : null;
        var price = priceEl && priceEl.dataset.fcPriceLoaded === '1' ? priceEl.textContent.trim() : '';
        if (price) nm = nm + ' (' + price + ')';
        if (matchedKeys.length === 1) { singleVid = vid; singleSoldout = !!soldout; }
        var addBtn;
        if (soldout) {
          addBtn = '<span class="button button--sm fc-cab__msg-add fc-cab-row__soldout" aria-disabled="true">Out of stock</span>';
        } else {
          addBtn = vid ? '<a href="/cart/add?id=' + vid + '&quantity=1" data-fc-add-to-cart data-variant-id="' + vid + '" class="button button--sm fc-cab__msg-add">Add</a>' : '';
        }
        return '<span class="fc-cab__msg-cable"><strong>' + escapeHtml(nm) + '</strong>' + addBtn + '</span>';
      }).join('');
      var lead = matchedKeys.length === 1
        ? 'Found ' + total + ' matching model' + (total > 1 ? 's' : '') + ' — you need:'
        : 'Your radio can use ' + matchedKeys.length + ' cables:';
      html = '<span class="fc-cab__msg-ok" aria-hidden="true">✓</span> ' + lead + ' ' + labels;
      /* Buy-box copy (data-fc-bundle): one matched cable that is in stock also gets
         "Add PTT + cable", which puts the PTT variant chosen in the buy box AND the cable
         into the cart in one go (2026-09-21: the finder moved into the buy box so nobody
         can add a PTT without having been asked which radio it is for). */
      var bundleBtn = (singleVid && !singleSoldout)
        ? ' <a href="/cart/add?id=' + singleVid + '&quantity=1" data-fc-add-to-cart data-fc-bundle-ptt data-variant-id="' + singleVid + '" class="button button--sm fc-cab__msg-add fc-cab__msg-bundle">Add PTT + cable</a>'
        : '';
      msgs.forEach(function (m) {
        m.innerHTML = html + (m.hasAttribute('data-fc-bundle') ? bundleBtn : '');
        m.hidden = false; m.classList.remove('is-nomatch');
      });
    } else {
      html = '<span class="fc-cab__msg-x" aria-hidden="true">✕</span> No match for “' + escapeHtml(value.trim()) +
             '”. Use <strong>Request a cable</strong> below — we support 1200+ models.';
      msgs.forEach(function (m) { m.innerHTML = html; m.hidden = false; m.classList.add('is-nomatch'); });
    }
    applySearch(t);
  }

  function initFinder() {
    var inputs = document.querySelectorAll('#fcRadioSearch');
    if (!inputs.length) return;
    buildModelPanels();
    // wire row toggles
    document.querySelectorAll('.fc-cab-row__toggle').forEach(function (btn) {
      if (btn.dataset.fcInit === '1') return;
      btn.dataset.fcInit = '1';
      btn.addEventListener('click', function () {
        var row = btn.closest('.fc-cab-row');
        var open = row.classList.contains('is-open');
        setRowExpanded(row, !open);
      });
    });
    // wire search inputs
    inputs.forEach(function (input) {
      if (input.dataset.fcInit !== '1') {
        input.dataset.fcInit = '1';
        input.addEventListener('input', function (e) {
        // keep every finder input (buy box + Find Your Downlead section) showing the same term
        document.querySelectorAll('#fcRadioSearch').forEach(function (o) { if (o !== e.target && o.value !== e.target.value) o.value = e.target.value; });
        searchFromInput(e.target.value);
      });
      }
    });
  }

  /* ===== Live availability =====
     The cable rows and adapter cards live in fc2.showcase_html, so each buy control
     used to be a hand-typed snapshot of stock at authoring time: it went stale on every
     sell-out (dead "Add" that 422s at /cart/add.js) and on every restock (a sold-out
     label on a product we can ship). The price fetch below already receives the
     variant's `available` flag, so the button is driven from it. The authored HTML is
     now only the pre-JS default; on fetch failure the page degrades to it. */
  /* Loose controls: the PTT Cables & Compatibility page renders inline-styled buy
     buttons with no wrapper class, so they are mutated in place rather than swapped,
     and the original href + label are stashed so the change is reversible. */
  function looseControlFor(priceEl, vid) {
    var sel = '[data-fc-add-to-cart][data-variant-id="' + vid + '"],'
            + '[data-fc-soldout-applied][data-variant-id="' + vid + '"]';
    var node = priceEl.parentNode;
    while (node && node.nodeType === 1 && node !== document.body) {
      var hit = node.querySelector(sel);
      if (hit) return hit;
      node = node.parentNode;
    }
    return null;
  }
  function setLooseState(el, available) {
    if (!available) {
      if (el.dataset.fcSoldoutApplied === '1') return;
      el.dataset.fcHref = el.getAttribute('href') || '';
      el.dataset.fcLabel = el.textContent;
      el.dataset.fcSoldoutApplied = '1';
      el.removeAttribute('href');
      el.removeAttribute('data-fc-add-to-cart');
      el.setAttribute('aria-disabled', 'true');
      el.textContent = 'Out of stock';
      el.style.background = '#e2e0da';
      el.style.color = '#6b6b64';
      el.style.cursor = 'not-allowed';
      el.style.pointerEvents = 'none';
    } else {
      if (el.dataset.fcSoldoutApplied !== '1') return;
      if (el.dataset.fcHref) el.setAttribute('href', el.dataset.fcHref);
      el.setAttribute('data-fc-add-to-cart', '');
      el.removeAttribute('aria-disabled');
      el.textContent = el.dataset.fcLabel || 'Add to Cart';
      el.style.background = '';
      el.style.color = '';
      el.style.cursor = '';
      el.style.pointerEvents = '';
      delete el.dataset.fcSoldoutApplied;
      delete el.dataset.fcHref;
      delete el.dataset.fcLabel;
    }
  }

  function syncAvailability(priceEl, variant) {
    var scope = priceEl.closest('.fc-mcard__buy') || priceEl.closest('.fc-cab-row__main');
    if (!scope) {
      var loose = looseControlFor(priceEl, String(variant.id));
      if (loose) setLooseState(loose, !!variant.available);
      return; /* prose prices (e.g. .fc-cab-note) have no buy control at all */
    }
    var current = scope.querySelector('[data-fc-add-to-cart], .fc-mcard__soldout, .fc-cab-row__soldout');
    if (!current) return;
    var available = !!(variant && variant.available);
    var soldoutNow = current.hasAttribute('aria-disabled');
    if (available !== soldoutNow) return; /* already correct - leave the DOM alone */
    var isRow = scope.classList.contains('fc-cab-row__main');
    var vid = String(variant.id);
    var next;
    if (available) {
      next = document.createElement('a');
      next.className = isRow ? 'button button--sm fc-cab-row__add' : 'button button--sm';
      next.setAttribute('href', '/cart/add?id=' + vid + '&quantity=1');
      next.setAttribute('data-fc-add-to-cart', '');
      next.setAttribute('data-variant-id', vid);
      next.textContent = isRow ? 'Add' : 'Add to Cart';
    } else {
      next = document.createElement('span');
      next.className = isRow
        ? 'button button--sm fc-cab-row__add fc-cab-row__soldout'
        : 'button button--sm fc-mcard__soldout';
      next.setAttribute('aria-disabled', 'true');
      next.textContent = 'Out of stock';
    }
    current.parentNode.replaceChild(next, current);
    var row = priceEl.closest('.fc-cab-row');
    if (row) { /* keeps the search-result Add button honest too */
      if (available) delete row.dataset.fcSoldout;
      else row.dataset.fcSoldout = '1';
    }
  }

  /* ===== Live price ===== */
  function updatePrices() {
    var priceEls = document.querySelectorAll('[data-fc-price-for]');
    if (!priceEls.length) return;
    priceEls.forEach(function (el) {
      if (el.dataset.fcPriceLoaded === '1') return;
      var handle = el.dataset.fcPriceFor;
      var variantId = el.dataset.fcVariantId;
      if (!handle) return;
      el.dataset.fcPriceLoaded = '1';
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var v = variantId ? p.variants.find(function (x) { return String(x.id) === variantId; }) : p.variants[0];
          if (!v) v = p.variants[0];
          if (!v) return;
          var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
          var formatted;
          try { formatted = (v.price / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
          catch (e) { formatted = '€' + (v.price / 100).toFixed(2); }
          var prefix = el.dataset.fcPricePrefix || '';
          el.textContent = prefix + formatted;
          syncAvailability(el, v);
        })
        .catch(function () { el.dataset.fcPriceLoaded = '0'; });
    });
  }

  /* ===== Add-to-cart with cart drawer refresh ===== */
  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) return;
        var oldDrawer = document.getElementById('cart-drawer');
        if (!oldDrawer) return;
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var newDrawer = doc.getElementById('cart-drawer') || doc.querySelector('cart-drawer');
        if (newDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
      });
  }
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('cart-count').forEach(function (c) {
          var n = c.querySelector('[aria-hidden="true"]');
          if (n) n.textContent = cart.item_count;
          if (cart.item_count > 0) c.classList.remove('opacity-0');
        });
        return cart;
      });
  }
  function openCartDrawer() {
    var trigger = document.querySelector('a[aria-controls="cart-drawer"]');
    if (trigger) { trigger.click(); return; }
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show();
  }
  function handleDelegatedClick(e) {
    var el = e.target;
    while (el && el !== document.body) {
      if (el.hasAttribute && el.hasAttribute('data-fc-add-to-cart')) break;
      el = el.parentNode;
    }
    if (!el || el === document.body) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var variantId = el.dataset.variantId;
    if (!variantId) { console.warn('[fc] add-to-cart missing data-variant-id'); return; }
    var items = [{ id: variantId, quantity: 1 }];
    if (el.hasAttribute('data-fc-bundle-ptt')) {
      // the PTT variant + quantity currently selected in the buy box, read at click time so
      // a colour change after the search still ships the right PTT
      var pttForm = document.querySelector('.product-info form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      var pttId = pttForm ? (pttForm.querySelector('[name="id"]') || {}).value : '';
      var qtyEl = pttForm ? pttForm.querySelector('[name="quantity"]') : null;
      var qtyDoc = document.querySelector('.product-info [name="quantity"]');
      var qty = parseInt((qtyEl && qtyEl.value) || (qtyDoc && qtyDoc.value) || '1', 10) || 1;
      if (!pttId) { console.warn('[fc] bundle: PTT variant not found in buy box'); return; }
      items = [{ id: pttId, quantity: qty }, { id: variantId, quantity: 1 }];
    }
    var orig = el.textContent;
    el.textContent = 'Adding...'; el.style.opacity = '0.7';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (body) { if (!r.ok) { throw new Error(body && body.description ? body.description : 'add failed'); } return body; }); })
      .then(function () { el.textContent = 'Added ✓'; return Promise.all([refreshCartCount(), refreshCartDrawer()]); })
      .then(function () { openCartDrawer(); setTimeout(function () { el.textContent = orig; el.style.opacity = '1'; }, 1500); })
      .catch(function (err) { console.error('[fc] error', err); el.textContent = 'Try again'; el.style.opacity = '1'; setTimeout(function () { el.textContent = orig; }, 2000); });
  }

  if (!document.body || document.body.dataset.fcDelegationBound !== '1') {
    document.addEventListener('click', handleDelegatedClick, true);
    if (document.body) document.body.dataset.fcDelegationBound = '1';
  }

  /* ===== Whole-card click -> product page (Add button + soldout stay separate) ===== */
  function handleCardLinkClick(e) {
    var t = e.target;
    // ignore clicks on the buy area, any add-to-cart control, or the sold-out span
    if (t.closest && (t.closest('.fc-mcard__buy') || t.closest('[data-fc-add-to-cart]') || t.closest('.fc-mcard__soldout') || t.closest('a'))) return;
    var card = t.closest && t.closest('.fc-mcard[data-fc-card-link]');
    if (!card) return;
    var href = card.getAttribute('data-fc-card-link');
    if (href) window.location.href = href;
  }
  if (!document.body || document.body.dataset.fcCardLinkBound !== '1') {
    document.addEventListener('click', handleCardLinkClick, false);
    if (document.body) document.body.dataset.fcCardLinkBound = '1';
  }

  function boot() { initFinder(); updatePrices(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () { initFinder(); updatePrices(); });
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener('DOMContentLoaded', function () { observer.observe(document.body, { childList: true, subtree: true }); });
  }
})();

/* ------------------------------------------------------------------
   Buy-box "Find your downlead" link -> the Find Your Downlead section
   (2026-08-12).

   theme.js delegates EVERY same-page a[href*="#"] click into
   anchorElement.scrollIntoView({behavior:'smooth'}), and native smooth
   scrolling is non-functional page-wide on this theme (the same finding
   the fc2-nav bar's inline script documents, 2026-06-11). The result is
   that the notice's link did nothing at all when clicked.

   So the jump is done here, with the fc2-nav bar's own arithmetic
   (sticky header + tab bar + 8px) and its own rAF loop of INSTANT
   scrolls. Bound in the capture phase so theme.js sees defaultPrevented
   and skips its dead smooth scroll; if it runs first anyway, its
   scrollIntoView is a no-op and this still lands the jump. Any failure
   is swallowed - the worst case is the browser's own anchor behaviour.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (document.body && document.body.dataset.fcCabnoteBound === '1') return;

  function stickyOffset() {
    try {
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;height:var(--sticky-area-height,0px)';
      document.body.appendChild(probe);
      var h = probe.getBoundingClientRect().height;
      probe.remove();
      var bar = document.querySelector('.fc2-nav__bar');
      return h + (bar ? bar.getBoundingClientRect().height : 0) + 8;
    } catch (e) { return 0; }
  }

  function jumpTo(y) {
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var maxY = (document.scrollingElement || document.documentElement).scrollHeight - window.innerHeight;
    y = Math.max(0, Math.min(y, maxY));
    if (reduce || !window.requestAnimationFrame) { window.scrollTo(0, y); return; }
    var from = window.scrollY, dist = y - from, t0 = null, dur = 400;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, from + dist * e);
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  document.addEventListener('click', function (e) {
    try {
      var link = e.target && e.target.closest && e.target.closest('.fc-cabnote__link');
      if (!link) return;
      var hash = (link.getAttribute('href') || '').replace(/^[^#]*#/, '');
      var target = hash && document.getElementById(hash);
      if (!target) return; /* no target: let the browser have the hash */
      e.preventDefault();
      jumpTo(window.scrollY + target.getBoundingClientRect().top - stickyOffset());
    } catch (err) { /* never break the page for a scroll */ }
  }, true);

  if (document.body) document.body.dataset.fcCabnoteBound = '1';
})();
